export const managementLabel = {
    tableTitle: "심사위원 목록",
    buttons: {
      add: "추가하기",
    },
    apiRequestFailMessage:
      "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
  };
  
//   export const reviewStatusLabel = {
//     tableTitle: "심사 현황",
//     apiRequestFailMessage:
//       "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
//   };
  
//   export const editReviewLabel = {
//     cardTitle: "심사 하기",
//     titles: {
//       paper: "투고 정보",
//       review: "심사 의견",
//       result: "게재 여부",
//       comment: "심사 내용",
//     },
//     buttons: {
//       pdf: "pdf",
//       close: "닫기",
//       temporarySave: "임시저장",
//       submit: "제출",
//     },
//     totalScore: "총점: ",
//     apiRequestFailMessage:
//       "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
//   };
  
//   export const showReviewLabel = {
//     cardTitle: "심사 내용",
//     titles: {
//       paper: "투고 정보",
//       review: "심사 의견",
//       result: "게재 여부",
//       comment: "심사 내용",
//     },
//     buttons: {
//       pdf: "pdf",
//       close: "닫기",
//     },
//     totalScore: "총점: ",
//     apiRequestFailMessage:
//       "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
//   };
  